import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ba8fcae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "column" }
const _hoisted_2 = ["value", "disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "armor-stat-bubble" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Armor")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.breakArmor && _ctx.breakArmor(...args)))
    }, [
      _createElementVNode("input", {
        id: "armor-stat-bubble",
        type: "number",
        value: _ctx.armor,
        disabled: !_ctx.editMode,
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveChange && _ctx.saveChange(...args))),
        class: _normalizeClass(_ctx.armor > 0 && !_ctx.editMode ? 'blue' : '')
      }, null, 42, _hoisted_2)
    ]),
    _hoisted_3
  ]))
}